import { fa } from "@/features/course/components/course-format";
import { INSTALMENT_ENABLED, MIN_INSTALMENT_VALUE } from "@/utils/constant";

// Matches the four monthly instalments charged by SnappPay.
const INSTALMENT_COUNT = 4;

type Props = {
  finalPrice: number;
  isFree?: boolean;
};

export default function CourseInstallmentBadge({
  finalPrice,
  isFree = false,
}: Props) {
  if (
    !INSTALMENT_ENABLED ||
    isFree ||
    finalPrice < MIN_INSTALMENT_VALUE
  ) {
    return null;
  }

  return (
    <div className="w-full absolute left-0 bottom-0 p-1">
      <div className="flex items-center justify-between p-1 w-full rounded-lg bg-white/90 text-black text-xs">
        <div className="size-7 text-white bg-purple-500 bg-gradient-to-tr from-indigo-500 to-indigo-400 flex flex-col justify-center items-center rounded-md">
          <span className="leading-none font-bold">{fa(INSTALMENT_COUNT)}</span>
          <span className="leading-none text-[6px]">قسط</span>
        </div>
        <div className="flex items-center gap-1">
          <p className="font-bold">
            {fa(Math.ceil(finalPrice / INSTALMENT_COUNT))}
          </p>
          <p className="text-xxs text-default-900">تومانی</p>
        </div>
      </div>
    </div>
  );
}
